import React from 'react';
import { HighlightItem } from '../../queries/homePage/highlights';
import {
  HighlightList,
  HighlightTitle,
  HighlightWrapper,
} from './Highlights.style';
import homeResource from '../../locales/th/home.json';
import { HighlightCard } from './HighlightCard';

export interface HighlightsProps {
  highlights: HighlightItem[];
  onClickHighlightCard?: (highlight: HighlightItem) => void;
}

export const Highlights: React.FC<HighlightsProps> = ({
  highlights,
  onClickHighlightCard,
}) => {
  if (!highlights?.length) return null;

  return (
    <HighlightWrapper>
      <HighlightTitle>{homeResource.highlight.title}</HighlightTitle>
      <HighlightList>
        {highlights.map((item, index) => (
          <HighlightCard
            highlight={item}
            key={index}
            onClickHighlightCard={(highlight) =>
              onClickHighlightCard(highlight)
            }
          />
        ))}
      </HighlightList>
    </HighlightWrapper>
  );
};
